<script setup>
import LanguageSelector from '@/Components/LanguageSelector.vue';
import { Link, router } from '@inertiajs/vue3';
import { onUnmounted } from 'vue';

const isServer = typeof window === 'undefined'

if (!isServer) {
    onUnmounted(
        router.on('navigate', (event) => {
            // console.log(`Navigated to ${event.detail.page.url}`);
            document.dispatchEvent(new Event('init-tooltips'));
            document.documentElement.style.overflow = 'auto';
        })
    )
}

</script>

<script>
export default {
    methods: {

        toggleMobileNav() {

            if (!this.$refs.mobileNav.classList.contains('mobile-nav-opened')) {
                this.$refs.mainNavbar.classList.add('mobile-nav-opened');
                this.$refs.mobileNav.classList.add('mobile-nav-opened');
                this.$refs.mobileNavToggler.classList.add('mobile-nav-toggler-toggled');
                document.documentElement.style.overflow = 'hidden';
            } else {
                this.$refs.mainNavbar.classList.remove('mobile-nav-opened');
                this.$refs.mobileNav.classList.remove('mobile-nav-opened');
                this.$refs.mobileNavToggler.classList.remove('mobile-nav-toggler-toggled');
                document.documentElement.style.overflow = 'auto';
            }

        }
    }
}
</script>

<template>
    <nav class="navbar navbar-expand-xl fixed-top main-navbar">
        <div class="container">
            <a :href="route('home')" class="navbar-brand">
                <img src="../../images/logo.png" alt="miniBUD" width="133" height="32" />
            </a>
            <button class="navbar-toggler mobile-nav-toggler" aria-label="Menu" @click="toggleMobileNav" ref="mobileNavToggler">
                <span class="mobile-nav-toggler-bar"></span>
                <span class="mobile-nav-toggler-bar"></span>
                <span class="mobile-nav-toggler-bar"></span>
            </button>
            <div class="collapse navbar-collapse" ref="mainNavbar">
                <ul class="navbar-nav me-auto">
                    <li class="nav-item">
                        <Link :href="route('booking')" class="nav-link">{{ $t('Transzfer foglalás') }}</Link>
                    </li>
                    <li class="nav-item">
                        <Link :href="route('return')" class="nav-link">{{ $t('Retúr jegyérvényesítés') }}</Link>
                    </li>
                    <li class="nav-item" v-if="!$page.props?.user?.isB2B && false">
                        <Link :href="route('services')" class="nav-link">{{ $t('Extra szolgáltatások') }}</Link>
                    </li>
                    <li class="nav-item">
                        <Link :href="route('partners')" class="nav-link">{{ $t('Partnerség') }}</Link>
                    </li>
                    <li class="nav-item" v-if="$page.props?.sziget?.enabled">
                        <a :href="$page.props?.sziget?.url" class="nav-link" target="_blank">{{ $t('Sziget') }}</a>
                    </li>
                    <li class="nav-item">
                        <Link :href="route('career')" class="nav-link">{{ $t('Karrier') }}</Link>
                    </li>
                    <li class="nav-item">
                        <Link :href="route('about')" class="nav-link">{{ $t('Transzferről') }}</Link>
                    </li>
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item ms-2 bg-white bg-opacity-10 rounded">
                        <Link v-if="!$page.props?.user" :href="route('login')" class="nav-link">{{ $t('Bejelentkezés') }}</Link>
                        <Link v-else :href="route('profile')" class="nav-link fw-bold text-white"><i v-if="$page.props?.user?.isB2B" class="fas me-1" :class="{ 'fa-hotel': $page.props?.user?.isHotel, 'fa-handshake': $page.props?.user?.isPartner }"></i> {{ $page.props.user.name }}</Link>
                    </li>
                    <li class="nav-item dropdown ms-2">
                        <a class="nav-link dropdown-toggle fw-bold text-white" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ $page.props.locale.toUpperCase() }}</a>
                        <ul class="dropdown-menu dropdown-menu-lg-end dropdown-menu-dark bg-primary m-0">
                            <LanguageSelector list-class="text-uppercase" link-class="dropdown-item fw-bold text-white" :country-code="true" />
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="mobile-nav" ref="mobileNav">
        <nav>
            <ul class="navbar-nav">
                <li class="nav-item">
                    <Link :href="route('booking')" class="nav-link" @click="toggleMobileNav">{{ $t('Transzfer foglalás') }}</Link>
                </li>
                <li class="nav-item">
                    <Link :href="route('return')" class="nav-link" @click="toggleMobileNav">{{ $t('Retúr jegyérvényesítés') }}</Link>
                </li>
                <li class="nav-item" v-if="!$page.props?.user?.isB2B && false">
                    <Link :href="route('services')" class="nav-link" @click="toggleMobileNav">{{ $t('Extra szolgáltatások') }}</Link>
                </li>
                <li class="nav-item">
                    <Link :href="route('partners')" class="nav-link" @click="toggleMobileNav">{{ $t('Partnerség') }}</Link>
                </li>
                <li class="nav-item" v-if="$page.props?.sziget?.enabled">
                    <a :href="$page.props?.sziget?.url" class="nav-link text-danger" target="_blank">{{ $t('Sziget') }}</a>
                </li>
                <li class="nav-item">
                    <Link :href="route('career')" class="nav-link" @click="toggleMobileNav">{{ $t('Karrier') }}</Link>
                </li>
                <li class="nav-item">
                    <Link :href="route('about')" class="nav-link" @click="toggleMobileNav">{{ $t('Transzferről') }}</Link>
                </li>
                <li class="nav-item">
                    <Link v-if="!$page.props?.user" :href="route('login')" class="nav-link" @click="toggleMobileNav">{{ $t('Bejelentkezés') }}</Link>
                    <Link v-else :href="route('profile')" class="nav-link" @click="toggleMobileNav">{{ $page.props.user.name }} - {{ $t('Profil') }}</Link>
                </li>
                <li class="mb-2 border-bottom"></li>
                <!--
                <li class="nav-item">
                    <Link href="javascript:;" class="nav-link" @click="toggleMobileNav">{{ $t('B2B bejelentkezés') }}
                    </Link>
                </li>
                -->
                <LanguageSelector list-class="nav-item" link-class="nav-link" :country-code="false" />
            </ul>
        </nav>
    </div>

    <slot />

    <section class="section section-darkgray">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="card bg-transparent border-0 text-center">
                        <div class="card-body">
                            <i class="fas fa-4x fa-envelope-open-text"></i>
                            <div class="h4 fw-bold my-4">{{ $t('Kapcsolat') }}</div>
                            <p v-html="$t('Kérdés vagy probléma esetén vegye fel velünk a kapcsolatot. Kollégáink a nap 24 órájában fogadják hívásaikat és válaszolnak üzeneteikre.')">
                            </p>
                            <Link :href="route('about')" class="stretched-link"><span class="visually-hidden">{{ $t('Kapcsolat') }}</span></Link>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card bg-transparent border-0 text-center">
                        <div class="card-body">
                            <i class="fas fa-4x fa-comments-alt"></i>
                            <div class="h4 fw-bold my-4">{{ $t('GYIK') }}</div>
                            <p v-html="$t('A gyakran ismételt kérdések segítenek Önnek abban, hogy a szolgáltatásainkkal kapcsolatos kérdéseire gyorsan és könnyen választ kapjon.')">
                            </p>
                            <Link :href="route('faq')" class="stretched-link"><span class="visually-hidden">{{ $t('GYIK') }}</span></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <footer class="footer">

        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <img src="../../images/logo.png" alt="miniBUD" width="200" height="48" class="my-3" />
                    <p class="my-3">Copyright &copy; {{ new Date().getFullYear() }} All rights reserved - miniBUD Kft.</p>
                    <div class="my-3">
                        <a :href="$page.props.locale == 'hu' ? '/storage/docs/terms-and-conditions-hu.pdf' : '/storage/docs/terms-and-conditions-en.pdf'" class="footer-button me-2" target="_blank">{{ $t('miniBUD Kft. ÁSZF') }}</a>
                        <a :href="$page.props.locale == 'hu' ? '/storage/docs/privacy-policy-hu.pdf' : '/storage/docs/privacy-policy-en.pdf'" class="footer-button ms-2" target="_blank">{{ $t('Adatvédelmi Szabályzat') }}</a>
                    </div>
                    <div class="my-3">
                        <a v-if="false" href="https://www.instagram.com/minibud_budapest/" aria-label="miniBUD Instagram" target="_blank" class="text-white me-2" rel="noopener"><i class="fab fa-3x fa-instagram"></i></a>
                        <a href="https://www.facebook.com/miniBUD1/" aria-label="miniBUD Facebook" target="_blank" class="text-white ms-2" rel="noopener"><i class="fab fa-3x fa-facebook-square"></i></a>
                    </div>
                </div>
            </div>
        </div>

    </footer>
</template>
